const getLocalDateTimeFormatter = (locale: string | undefined, includeTime: boolean) => {
  return new Intl.DateTimeFormat(locale, {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: includeTime ? 'numeric' : undefined,
    minute: includeTime ? 'numeric' : undefined,
    timeZoneName: includeTime ? 'short' : undefined,
  });
};

export const getLocalFormattedDate = (
  date: Date | number,
  locale: string | undefined,
  includeTime: boolean,
): string => {
  const localDateTimeFormatter = getLocalDateTimeFormatter(locale, includeTime);

  return localDateTimeFormatter.format(date);
};
